<template>
  <div>
    <a-card title="太仓港国际货运有限公司" :bordered="false" :headStyle="{ 'font-weight': 'bold','font-size': '24px' }" style="margin-top:24px;">
      <a-row type="flex" justify="center">
        <a-col :span="20" >
          <p>地址：太仓市郑和路309号太仓发展大厦9楼</p>
          <p>联系电话：0512-53998108</p>
          <p>业务联系：0512-53562531</p>
          <p>传真：0512-53561691</p>
        </a-col>
      </a-row>
    </a-card>
    <a-card title="太仓市报关公司" :bordered="false" :headStyle="{ 'font-weight': 'bold','font-size': '24px' }">
      <a-row type="flex" justify="center">
        <a-col :span="20" >
          <p>地址：太仓市郑和路309号太仓发展大厦9楼 / 太仓港区联检服务大楼9楼</p>
          <p>联系电话：0512-53573677</p>
          <p>传真：0512-53573677</p>
        </a-col>
      </a-row>
    </a-card>
    <a-card title="太仓金港国际贸易技术服务有限公司" :bordered="false" :headStyle="{ 'font-weight': 'bold','font-size': '24px' }">
      <a-row type="flex" justify="center">
        <a-col :span="20" >
          <p>地址：太仓市郑和路309号太仓发展大厦9楼 / 太仓港区联检服务大楼9楼</p>
          <p>联系电话：0512-53592169</p>
        </a-col>
      </a-row>
    </a-card>
    <a-card title="太仓远太国际船舶代理有限公司" :bordered="false" :headStyle="{ 'font-weight': 'bold','font-size': '24px' }">
      <a-row type="flex" justify="center">
        <a-col :span="20" >
          <p>地址：太仓市郑和路309号太仓发展大厦9楼 / 太仓港区联检服务大楼9楼</p>
          <p>联系电话：0512-53569699</p>
          <p>传真：0512-53569728</p>
        </a-col>
      </a-row>
    </a-card>
  </div>
</template>

<script>

export default {
  name: 'Contact',
}
</script>

<style scoped>
p {
  font-size: 16px;
}
</style>
